var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2506 20.0768C19.4748 20.0768 22.0886 17.4631 22.0886 14.2389C22.0886 11.0147 19.4748 8.40099 16.2506 8.40099C13.0264 8.40099 10.4127 11.0147 10.4127 14.2389C10.4127 17.4631 13.0264 20.0768 16.2506 20.0768Z",
    fill: "#4D5C6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5211 4.82832H24.7286C24.2954 4.82832 23.89 4.61138 23.6493 4.25102L21.8251 1.5144C21.5844 1.15259 21.179 0.936371 20.7455 0.936371H11.7554C11.3223 0.936371 10.9169 1.15295 10.6761 1.5144L8.85197 4.25102C8.61125 4.61138 8.20583 4.82832 7.77231 4.82832H1.98015C0.905184 4.82832 0.0341797 5.70005 0.0341797 6.7743V22.9908C0.0341797 24.0654 0.905184 24.9364 1.98015 24.9364H30.5211C31.5961 24.9364 32.4671 24.0654 32.4671 22.9908V6.7743C32.4671 5.70005 31.5961 4.82832 30.5211 4.82832ZM16.2506 22.0228C11.9583 22.0228 8.46674 18.5316 8.46674 14.2389C8.46674 9.94804 11.9583 6.45465 16.2506 6.45465C20.543 6.45465 24.0345 9.94768 24.0345 14.2389C24.0345 18.5312 20.543 22.0228 16.2506 22.0228ZM25.9805 7.7599C25.9805 8.1145 25.6933 8.40099 25.3383 8.40099H25.3254C24.9708 8.40099 24.6828 8.1145 24.6828 7.7599V7.7462C24.6828 7.3916 24.9704 7.10403 25.3254 7.10403H25.3383C25.6929 7.10403 25.9805 7.3916 25.9805 7.7462V7.7599Z",
    fill: "#4D5C6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52078 2.23367H3.92615V3.53135H6.52078V2.23367Z",
    fill: "#4D5C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.ff759e43cfbd1b52b83e1377986bf0e2.svg";
export { ForwardRef as ReactComponent };